import React, { useState, useCallback } from "react"
import {
    componentStyles,
    Box,
    LoadingOrErrorContainer,
} from "@mallardbay/lib-react-components"

import useDashboardNavigationMenu from "~utils/hooks/useDashboardNavigationMenu"
import PortalEntitySelector from "~components/shared/portal-entity-selector/portal-entity-selector"
import SidebarItemGroup from "~components/shared/sidebar/sidebar-item-group"

type SidebarContentProps = {
    readonly isCollapsed: boolean
}

export default function SidebarContent({
    isCollapsed: isSidebarCollapsed,
}: SidebarContentProps): React.ReactElement {
    const styles = useStyles()
    const [collapsedGroups, setCollapsedGroups] = useState<Set<string>>(
        new Set()
    )

    const { menuGroups, isLoading, error } = useDashboardNavigationMenu()

    const toggleGroup = useCallback((groupName: string) => {
        setCollapsedGroups((prev) => {
            const newSet = new Set(prev)
            if (newSet.has(groupName)) {
                newSet.delete(groupName)
            } else {
                newSet.add(groupName)
            }
            return newSet
        })
    }, [])

    return (
        <>
            <Box style={styles.outfitterSelectContainer}>
                <PortalEntitySelector
                    shouldRenderSelectedEntity={!isSidebarCollapsed}
                />
            </Box>

            <LoadingOrErrorContainer
                style={styles.container}
                isLoading={isLoading}
                error={error}
                shouldRenderChildren
            >
                {menuGroups.map((menuGroup) => {
                    const isCollapsed = collapsedGroups.has(
                        menuGroup.label ?? ""
                    )

                    return (
                        <SidebarItemGroup
                            key={menuGroup.label}
                            menuGroup={menuGroup}
                            isCollapsed={isCollapsed}
                            onToggleGroup={toggleGroup}
                            isSidebarCollapsed={isSidebarCollapsed}
                        />
                    )
                })}
            </LoadingOrErrorContainer>
        </>
    )
}

function useStyles() {
    return componentStyles({
        container: {
            width: "100%",
        },
        outfitterSelectContainer: {
            paddingX: 3,
            paddingTop: 5,
        },
    })
}
